<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Corporate
            </template>
            <template v-slot:pageDetail>
                {{ page.cardTitle }}
            </template>
            <template v-slot:pageDescription>
                <br>
            </template>
        </o-bread-crumb>
        

        <div class="d-flex justify-content-start">
            <o-card :card-title="page.cardTitle" class="custom-table mw-700">
                <o-form @submit.prevent="change()" autocomplete="off">
                    <div class="d-flex justify-content-between me-2">
                        <div class="col-md-6 me-2">
                          <o-form-group title="code" name="code">
                            <span class="text-danger"> *</span>
                            <o-input-text name="code" v-model="corporate.code" type="text" :autocomplete="'off'"/>
                            <div v-if="validation.code">
                              <div class="alert alert-danger mt-1" role="alert">
                                {{ validation.code[0] }}
                              </div>
                            </div>
                          </o-form-group>
                        </div>
                        <div class="col-md-6">
                          <o-form-group title="slug name" name="slug_name">
                            <span class="text-danger"> *</span>
                            <o-input-text name="slug_name" :autocomplete="'off'" v-model="corporate.slug_name" type="text"/>
                            <div v-if="validation.slug_name">
                              <div class="alert alert-danger mt-1" role="alert">
                                {{ validation.slug_name[0] }}
                              </div>
                            </div>
                          </o-form-group>
                        </div>
                      </div>
                        <o-form-group title="name" name="name" >
                            <span class="text-danger"> *</span>
                            <o-input-text name="name" :autocomplete="'off'" v-model="corporate.name" type="text" />
                            <div v-if="validation.name">
                                <div class="alert alert-danger mt-1" role="alert">
                                {{ validation.name[0] }}
                                </div>
                            </div>
                        </o-form-group>
                    <div class="d-flex justify-content-between me-2">
                        <div class="col me-2">
                            <o-form-group title="city/area" name="city">
                                <span class="text-danger"> *</span>
                                <o-input-text name="city" v-model="corporate.city" type="text" autocomplete="'off'"></o-input-text>
                                <div v-if="validation.city">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.city[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                        <div class="col me-2">
                            <o-form-group title="state/province" name="state" >
                                <span class="text-danger"> *</span>
                                <o-input-text name="state" v-model="corporate.state" type="text" autocomplete="'off'"/>
                                <div v-if="validation.state">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.state[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between me-2">
                        <div class="col me-2">
                            <o-form-group title="postcode" name="postcode">
                                <span class="text-danger"> *</span>
                                <o-input-text name="postcode" v-model="corporate.postcode" type="text" autocomplete="'off'"></o-input-text>
                                <div v-if="validation.postcode">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.postcode[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                        <div class="col">
                            <o-form-group title="country" name="country">
                                <span class="text-danger"> *</span>
                                <o-select v-model="corporate.country" :options="countries" autocomplete="'off'"></o-select>
                                <div v-if="validation.country">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.country[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                    </div>
                    <o-form-group title="address" name="address">
                        <o-textarea 
                            name="address"
                            v-model="corporate.address"
                            placeholder="enter your additional address information"
                            style="height: 45px"
                            for="address"
                            id="address"
                            autocomplete="'off'"
                        ></o-textarea>
                        <div v-if="validation.address">
                            <div class="alert alert-danger mt-1" role="alert">
                                {{ validation.address[0] }}
                            </div>
                        </div>
                    </o-form-group>
                    <div class="d-flex d-inline-block justify-content-between me-2">
                        <div class="col-md-6 me-2">
                            <o-check-box v-model="domainType" :true-value="true" :false-value="false" :disabled="subdomainType">Domain</o-check-box>
                        </div>
                        <div class="col-md-6">
                            <o-check-box v-model="subdomainType" :true-value="true" :false-value="false" :disabled="domainType">Subdomain</o-check-box>
                        </div>
                    </div>
                    <div v-if="!domainType && !subdomainType && customErrorBox" class="alert alert-danger mt-1" role="alert">
                        Domain or Subdomain is required.
                    </div>
                    <div v-if="domainType || subdomainType" class="d-flex d-inline-block justify-content-between me-2">
                        <div class="col-md-6 me-2">
                            <o-form-group v-if="domainType" title="domain" name="custom_domain">
                                <o-input-text mask="domain" name="custom_domain" v-model="corporate.custom_domain" type="text"  autocomplete="'off'"/>
                                <div v-if="customDomainValidation">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        Please enter a domain in a valid format.
                                    </div>
                                </div>
                                <div v-if="customDomainError">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ customDomainError }}
                                    </div>
                                </div>
                                <div v-if="validation.custom_domain">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.custom_domain[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                        <div class="col-md-6">
                            <o-form-group v-if="subdomainType" title="subdomain" name="custom_subdomain">
                                <o-input-text mask="subdomain" name="custom_subdomain" v-model="corporate.custom_subdomain" type="text"  autocomplete="'off'"/>
                                <div v-if="customSubdomainValidation">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        Please enter a subdomain in a valid format.
                                    </div>
                                </div>
                                <div v-if="customSubdomainError">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ customSubdomainError }}
                                    </div>
                                </div>
                                <div v-if="validation.custom_subdomain">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.custom_subdomain[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                    </div>
                    <div class="d-flex d-inline-block justify-content-between me-2">
                        <div class="col-md-6 me-2">
                            <o-form-group title="phone" name="phone">
                                <span class="text-danger"> *</span>
                                <div class="d-flex">
                                    <div style="width: 25%;" v-if="!unknownCountry">
                                        <o-input-text
                                            name="countryCode"
                                            :autocomplete="'off'"
                                            v-model="countryCode"
                                            type="text"
                                            :readonly="true"
                                            :disabled="true"
                                        />
                                    </div>
                                    <div style="width: 100%;">
                                        <o-input-text
                                            name="phone"
                                            :autocomplete="'off'"
                                            v-model="corporate.phone"
                                            type="text"
                                            :numbers-only="true"
                                        />
                                    </div>
                                </div>
                                <div v-if="validation.phone">
                                    <div class="alert alert-danger mt-1" role="alert">
                                    {{ validation.phone[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                        <div class="col-md-6">
                            <o-form-group title="fax" name="fax">
                                <span class="text-danger"> *</span>
                                <o-input-text mask="fax" name="fax" v-model="corporate.fax" type="text"  autocomplete="'off'"/>
                                <div v-if="validation.fax">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.fax[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                    </div> 
                    <div class="d-flex justify-content-between me-2">
                        <div class="col-md-6 me-2">
                            <o-form-group title="website url" name="website">
                                <o-input-text name="website" v-model="corporate.website" type="text" autocomplete="'off'"/>
                                <div v-if="validation.website">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.website[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                        <div class="col-md-6">
                            <o-form-group title="commerce site" name="commerce">
                                <o-input-text name="commerce" v-model="corporate.commerce_site" type="text" autocomplete="'off'"/>
                                <div v-if="validation.commerce_site">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.commerce_site[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </div>
                    </div>
                    <o-form-group title="logo" name="logo" >
                        <span class="text-danger"> *</span>
                        <o-image-input name="logo" id="logo" :imageurl="image.url" @selectImage="imageHandling"></o-image-input>
                        <div v-if="validation.logo">
                            <div class="alert alert-danger mt-1" role="alert">
                                {{ validation.logo[0] }}
                            </div>
                        </div>
                    </o-form-group>
                    <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="page.isLoading"></div>
                    <div class="spinner" v-if='page.isLoading'></div>
                    <div class="button-container">
                        <o-button type="submit" :size="'sm'" :variant="'success'" :white="'white'">
                          Save
                        </o-button>
                        <o-button @click="cancel()" :size="'sm'" :variant="'primary'" :white="'white'">
                            Cancel
                        </o-button>
                    </div>
                </o-form>
            </o-card>
        </div>
    </div>
</template>

<script>
import { OCard, OForm, OFormGroup, OInputText, OButton, OTextarea, OSelect, OImageInput, OBreadCrumb, OCheckBox} from '@/components/OmnihControl';
import { reactive, ref, onMounted, watch} from 'vue'
import { useRouter, useRoute } from 'vue-router'
// import axios from 'axios'
import store from '@/store';
// import {mapState} from 'vuex'
import { isSupportedCountry, getCountryCallingCode } from 'libphonenumber-js';
import { getCode } from 'country-list';

export default {
    name: 'AddCorporate',
    components: {
        OCard,
        OForm,
        OFormGroup,
        OInputText,
        OButton,
        OTextarea,
        OSelect,
        OImageInput,
        OBreadCrumb,
        OCheckBox
    },
    setup(){
        const page = reactive({
            isLoading: false,
            cardTitle: 'Create Corporate'
        });

        const corporate = reactive({
            code : "",
            name : "",
            slug_name: "",
            logo : "",
            address : "",
            state : "",
            country : "",
            phone : "",
            fax : "",
            website: '',
            commerce_site: '',
            city: '',
            postcode: '',
            custom_domain: '',
            custom_subdomain: ''
        })

        const domainType = ref(false);
        const subdomainType = ref(false);

        const customDomainValidation = ref(false);
        const customSubdomainValidation = ref(false);

        const customDomainError = ref('');
        const customSubdomainError = ref('');

        const customErrorBox = ref('');

        const validDomainExtensions = [
            '.com', '.net', '.org', '.edu', '.gov', '.mil', '.int', '.co', '.io', '.biz', '.info', '.mobi', '.name', '.aero', '.asia', '.cat', '.jobs', '.museum', 
            '.ac', '.ad', '.ae', '.af', '.ag', '.ai', '.al', '.am', '.ao', '.aq', '.ar', '.as', '.at', '.au', '.aw', '.ax', '.az', 
            '.ba', '.bb', '.bd', '.be', '.bf', '.bg', '.bh', '.bi', '.bj', '.bm', '.bn', '.bo', '.br', '.bs', '.bt', '.bv', '.bw', '.by', '.bz', 
            '.ca', '.cc', '.cd', '.cf', '.cg', '.ch', '.ci', '.ck', '.cl', '.cm', '.cn', '.co', '.cr', '.cu', '.cv', '.cw', '.cx', '.cy', '.cz', 
            '.de', '.dj', '.dk', '.dm', '.do', '.dz', 
            '.ec', '.ee', '.eg', '.eh', '.er', '.es', '.et', 
            '.fi', '.fj', '.fk', '.fm', '.fo', '.fr', 
            '.ga', '.gb', '.gd', '.ge', '.gf', '.gg', '.gh', '.gi', '.gl', '.gm', '.gn', '.gp', '.gq', '.gr', '.gs', '.gt', '.gu', '.gw', '.gy', 
            '.hk', '.hm', '.hn', '.hr', '.ht', '.hu', 
            '.id', '.ie', '.il', '.im', '.in', '.io', '.iq', '.ir', '.is', '.it', 
            '.je', '.jm', '.jo', '.jp', 
            '.ke', '.kg', '.kh', '.ki', '.km', '.kn', '.kp', '.kr', '.kw', '.ky', '.kz', 
            '.la', '.lb', '.lc', '.li', '.lk', '.lr', '.ls', '.lt', '.lu', '.lv', '.ly', 
            '.ma', '.mc', '.md', '.me', '.mg', '.mh', '.mk', '.ml', '.mm', '.mn', '.mo', '.mp', '.mq', '.mr', '.ms', '.mt', '.mu', '.mv', '.mw', '.mx', '.my', '.mz', 
            '.na', '.nc', '.ne', '.nf', '.ng', '.ni', '.nl', '.no', '.np', '.nr', '.nu', '.nz', 
            '.om', 
            '.pa', '.pe', '.pf', '.pg', '.ph', '.pk', '.pl', '.pm', '.pn', '.pr', '.ps', '.pt', '.pw', '.py', 
            '.qa', 
            '.re', '.ro', '.rs', '.ru', '.rw', 
            '.sa', '.sb', '.sc', '.sd', '.se', '.sg', '.sh', '.si', '.sj', '.sk', '.sl', '.sm', '.sn', '.so', '.sr', '.ss', '.st', '.su', '.sv', '.sx', '.sy', '.sz', 
            '.tc', '.td', '.tf', '.tg', '.th', '.tj', '.tk', '.tl', '.tm', '.tn', '.to', '.tr', '.tt', '.tv', '.tw', '.tz', 
            '.ua', '.ug', '.uk', '.us', '.uy', '.uz', 
            '.va', '.vc', '.ve', '.vg', '.vi', '.vn', '.vu', 
            '.wf', '.ws', 
            '.ye', '.yt', 
            '.za', '.zm', '.zw'
        ];

        const image = reactive({
            url: ""
        });

        const validation = ref([]);
        
        const router = useRouter();

        const route = useRoute();

        const countries = ref([]);
        const countryCode = ref('');
        const unknownCountry = ref(false);
        const userCountry = ref();

        const baseDomain = ref('');

        watch(() => corporate.country, updatePhoneCode);

        onMounted(async() => {
            page.isLoading = true;

            await loadCountries();

            if(route.params.id !== undefined){
                await loadState(route.params.id);
            }

            baseDomain.value = localStorage.getItem('baseDomain');

            page.isLoading = false;
        });

        const loadCountries = async () => {
            try {
                const response = await store.dispatch('Countries/read');
                countries.value = response.map(country => ({ value: country.id, text: country.name }));
            } catch (err) {
                console.error(err);
            }
        }

        function updatePhoneCode() {
            if (!countries.value || countries.value.length === 0) {
                console.error('Countries data is not loaded yet.');
                return;
            }

            const countryName = countries.value.find(country => country.value === parseInt(corporate.country));

            if (countryName) {
                userCountry.value = countryName;
                const code = getCode(userCountry.value.text);
                if (isSupportedCountry(code)) {
                    unknownCountry.value = false;
                    const phoneCode = getCountryCallingCode(code);
                    if (phoneCode) {
                        countryCode.value = `+${phoneCode} `;
                    }
                } else {
                    unknownCountry.value = true;
                    console.error(`Unknown country: ${userCountry.value.text}`);
                }
            } else {
                unknownCountry.value = true;
                console.error(`Country not found for user country: ${corporate.country}`);
            }
        }

        const loadState = async (id) => {
            page.isLoading = true;

            try {
                const data = await store.dispatch('Corporate/read_single', id);

                corporate.country = data.business_profile.country;
                corporate.id = data.id;
                corporate.code = data.code;
                corporate.name = data.name;
                corporate.slug_name = data.slug_name;
                corporate.address = data.business_profile.address;
                corporate.state = data.business_profile.state;
                corporate.phone = removeCountryCode(data.business_profile.phone);
                corporate.fax = data.business_profile.fax;
                corporate.website = data.business_profile.website;
                corporate.commerce_site = data.business_profile.commerce_site;
                corporate.city = data.business_profile.city;
                corporate.postcode = data.business_profile.postcode;
                baseDomain.value = data.baseDomain;

                if (data?.custom_domain) {
                    domainType.value = true;
                    corporate.custom_domain = data.custom_domain;
                }
                if (data?.custom_subdomain) {
                    subdomainType.value = true;
                    corporate.custom_subdomain = data.custom_subdomain;
                }
                
                image.url = data.business_profile.logo.image_url;

            } catch (error) {
                console.error('Error loading state:', error);
            } finally {
                page.isLoading = false;
            }
        };

        const removeCountryCode = (phone) => {
            const countryName = countries.value.find(country => country.value === parseInt(corporate.country));
            if (countryName) {
                userCountry.value = countryName;
                const code = getCode(userCountry.value.text);
                if (isSupportedCountry(code)) {
                    const phoneCode = getCountryCallingCode(code);
                    if (phoneCode) {
                        const countryCodePattern = new RegExp(`^\\+${phoneCode}`);
                        return phone.replace(countryCodePattern, '').trim();
                    }
                } else {
                    unknownCountry.value = true;
                    console.error(`Unknown country: ${userCountry.value.text}`);
                }
            } else {
                unknownCountry.value = true;
                console.error(`Country not found for user country: ${corporate.country}`);
            }
            return phone;
        }

        function imageHandling(img){
            corporate.logo = img;
        }

        function isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        function change(){
            page.isLoading = true;
            const data={...corporate}

            data.domainType = domainType.value;
            data.subdomainType = subdomainType.value;
            // if (!data.phone) {
            //     validation.value.phone = ['Phone is required'];
            //     return;
            // }
            // data.phone = countryCode.value + data.phone;
            // customErrorBox.value = '';

            // if (!domainType.value && !subdomainType.value) {
            //     customErrorBox.value = 'Domain or Subdomain is required';
            //     return;
            // }

            // if (domainType.value && !data.custom_domain) {
            //     customErrorBox.value = 'Domain is required';
            //     return;
            // }

            // if (subdomainType.value && !data.custom_subdomain) {
            //     customErrorBox.value = 'Subdomain is required';
            //     return;
            // }

            // if (domainType.value) {
            //     data.custom_subdomain = '';

            //     if (customDomainError.value || customDomainValidation.value) {
            //         return;
            //     }
            // }
            // if (subdomainType.value) {
            //     data.custom_domain = '';

            //     if (customSubdomainError.value || customSubdomainValidation.value) {
            //         return;
            //     }
            // }

            if(route.name != 'CorporateForm'){
                page.cardTitle = 'Edit Corporate';

                if (data.logo == '') {
                    delete data.logo;
                }

                store.dispatch('Corporate/update',{data}).
                then(()=>{
                    router.push({
                        name: 'Corporate',
                    })
                }).catch((err) => {

                    if (isJsonString(err.response.data.error)) {
                        validation.value = JSON.parse(err.response.data.error)

                        if(validation.value.custom_domain && validation.value.custom_subdomain) {
                            customErrorBox.value = validation.value.custom_domain[0] + ' or ' + validation.value.custom_subdomain[0];
                        } else if (validation.value.custom_domain || (domainType.value && !data.custom_domain) ) {
                            customErrorBox.value = validation.value.custom_domain[0]  || 'Domain is required.';
                        } else if (validation.value.custom_subdomain || (subdomainType.value && !data.custom_subdomain)) {
                            customErrorBox.value = validation.value.custom_subdomain[0] || 'Subdomain is required.';
                        } else {
                            customErrorBox.value = '';
                        }

                        if (data.country === 0 || data.country === '') {
                            validation.value.country = ['Country is required.'];
                            page.isLoading = false;
                            return; 
                        } else {
                            delete validation.value.country;
                        }
                    } else {
                        const errorValue = err.response.data.error;

                        if (errorValue.includes('Subdomain')) {
                            customSubdomainError.value = errorValue;
                        }
                        if (errorValue.includes('Domain')) {
                            customDomainError.value = errorValue;
                        }
                    }
                }).finally(() =>{
                    page.isLoading = false
                });
            }else{
                page.cardTitle = 'Create Corporate';

                store.dispatch('Corporate/create',{data}).
                then(()=>{
                    router.push({
                        name: 'Corporate',
                        query: { newCorporate: 'true' }
                    })
                }).catch((err) => {

                    if (isJsonString(err.response.data.error)) {
                        validation.value = JSON.parse(err.response.data.error)
                        
                        if(validation.value.custom_domain && validation.value.custom_subdomain) {
                            customErrorBox.value = validation.value.custom_domain[0] + ' or ' + validation.value.custom_subdomain[0];
                        } else if (validation.value.custom_domain || (domainType.value && !data.custom_domain) ) {
                            customErrorBox.value = validation.value.custom_domain[0]  || 'Domain is required.';
                        } else if (validation.value.custom_subdomain || (subdomainType.value && !data.custom_subdomain)) {
                            customErrorBox.value = validation.value.custom_subdomain[0] || 'Subdomain is required.';
                        } else {
                            customErrorBox.value = '';
                        }

                        if (data.country === 0 || data.country === '') {
                            validation.value.country = ['Country is required.'];
                            page.isLoading = false;
                            return; 
                        } else {
                            delete validation.value.country;
                        }
                    } else {
                        const errorValue = err.response.data.error;

                        if (errorValue.includes('domain') && errorValue.includes(baseDomain.value)) {
                            customSubdomainError.value = errorValue;
                        }else if (errorValue.includes('Domain')) {
                            customDomainError.value = errorValue;
                        }else if (errorValue.includes('Subdomain')) {
                            customSubdomainError.value = errorValue;
                        }
                    }
                }).finally(() =>{
                    page.isLoading = false
                });
            }
        }

        function cancel() {
            router.push({ name: 'Corporate' });
        }

        // Watcher for custom_domain
        watch(() => corporate.custom_domain, (newValue) => {
            if (newValue === '') {
                customDomainValidation.value = false;
            } else {
                customDomainValidation.value = !isValidDomainFormat(newValue);
            }

            if (newValue.includes(baseDomain.value)) {
                customDomainError.value = `Don't put ${baseDomain.value} in the domain`;
            } else {
                customDomainError.value = '';
            }
        });

        // Watcher for custom_subdomain
        watch(() => corporate.custom_subdomain, (newValue) => {
            if (newValue === '') {
                customSubdomainValidation.value = false;
            } else {
                customSubdomainValidation.value = !isValidSubdomainFormat(newValue);
            }

            if (newValue.includes(baseDomain.value)) {
                customSubdomainError.value = `Don't put ${baseDomain.value} in the subdomain`;
            } else {
                customSubdomainError.value = '';
            }
        });

        const isValidDomainFormat = (domain) => {
            return validDomainExtensions.some(ext => domain.endsWith(ext));
        };

        const isValidSubdomainFormat = (subdomain) => {

            // Split the subdomain by dots and check each part
            const parts = subdomain.split('.');

            // Remove the last part (which is the main domain)
            parts.pop();

            // Join the remaining parts back into a string
            const subdomainWithoutMainDomain = parts.join('.');
            
            if (subdomainWithoutMainDomain === '') {
                return true;
            } else {
                // Check if the subdomain contains any valid domain extensions
                return subdomainWithoutMainDomain.length > 0 && !validDomainExtensions.some(ext => subdomain.endsWith(ext));
            }
        };

        return {
            corporate,
            page,
            validation,
            router,
            change,
            imageHandling,
            image,
            cancel,
            countryCode,
            unknownCountry,
            countries,
            domainType,
            subdomainType,
            customDomainValidation,
            customSubdomainValidation,
            customDomainError,
            customSubdomainError,
            customErrorBox
        }
    },
}
</script>
<style scoped>
.error-box {
    position: fixed;
    top: 0;
    left: 42%;
    background-color: #fc6666;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    z-index: 9999;
}

.error-transition-enter-active,
.error-transition-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.error-transition-enter-from,
.error-transition-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

.error-transition-enter-to,
.error-transition-leave-from {
    transform: translateY(0);
    opacity: 1;
}
</style>